import React from 'react';

import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

interface RiskInfoCardProps {
	title: string;
	text: string;
}

export function RiskInfoCard({ title, text }: Readonly<RiskInfoCardProps>) {
	return (
		<S.InfoCard>
			<S.InfoTitle>{title}</S.InfoTitle>
			<S.InfoText>{text}</S.InfoText>
		</S.InfoCard>
	);
}
